var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWheelIconL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 15c0 6.075-4.925 11-11 11S9 21.075 9 15 13.925 4 20 4s11 4.925 11 11zm-2.75 0a8.215 8.215 0 01-1.752 5.084l-3.79-3.79c.187-.392.292-.83.292-1.294 0-.463-.105-.902-.292-1.293l3.79-3.79A8.215 8.215 0 0128.25 15zm-6.957 2.708l3.79 3.79A8.215 8.215 0 0120 23.25a8.215 8.215 0 01-5.084-1.752l3.79-3.79c.392.187.83.292 1.294.292.463 0 .902-.105 1.293-.292zM20 12c-.463 0-.902.105-1.293.292l-3.79-3.79a8.213 8.213 0 013.664-1.63L20 9l1.419-2.128a8.213 8.213 0 013.665 1.63l-3.79 3.79A2.988 2.988 0 0020 12zm-2.708 1.707l-3.79-3.79A8.215 8.215 0 0011.75 15c0 1.918.654 3.683 1.752 5.084l3.79-3.79A2.988 2.988 0 0117 15c0-.463.105-.902.292-1.293zM12 32h4l3-4h2l3 4h4l1 1-1 1H12.002l-1-1L12 32z",
    fill: "#fff"
  })));
}

export default SvgWheelIconL;